/**
 * The Link Resolver used for the Prismic repository. This function converts a
 * Prismic document to a URL within your app. It is used throughout your app to
 * resolve document links and support editor previews.
 *
 * {@link https://prismic.io/docs/technologies/link-resolver-gatsby}
 *
 * @param doc Prismic document to resolve to a URL within your app.
 * @returns URL for the provided Prismic document.
 */

const defaultLanguage = require("../../config/site-config").default?.siteLang;

exports.linkResolver = (doc) => {
  switch (doc.type) {
    case "homepage": {
      return doc.lang === defaultLanguage ? "/" : `/${doc.lang.split("-")[0]}/`;
    }
    case "simple_page": {
      return doc.lang === defaultLanguage
        ? `/${doc.uid}/`
        : `/${doc.lang.split("-")[0]}/${doc.uid}/`;
    }
    case "loan_page": {
      return doc.lang === defaultLanguage
        ? `/${doc.uid}/`
        : `/${doc.lang.split("-")[0]}/${doc.uid}/`;
    }
    case "faq": {
      return doc.lang === defaultLanguage
        ? `/${doc.uid}/`
        : `/${doc.lang.split("-")[0]}/${doc.uid}/`;
    }
    case "contact": {
      return doc.lang === defaultLanguage
        ? `/contact/`
        : `/${doc.lang.split("-")[0]}/contact/`;
    }
    case "loan_calculation": {
      return doc.lang === defaultLanguage
        ? `/loan-calculation/`
        : `/${doc.lang.split("-")[0]}/loan-calculation/`;
    }
    case "about": {
      return doc.lang === defaultLanguage
        ? `/about/`
        : `/${doc.lang.split("-")[0]}/about/`;
    }
    case "complaint_page": {
      return doc.lang === defaultLanguage
        ? `/complaint-page/`
        : `/${doc.lang.split("-")[0]}/complaint-page/`;
    }
    case "blog": {
      return doc.lang === defaultLanguage
        ? `/blog/`
        : `/${doc.lang.split("-")[0]}/news/`;
    }
    case "blog_post": {
      return doc.lang === defaultLanguage
        ? `/${doc.uid}/`
        : `/${doc.lang.split("-")[0]}/${doc.uid}/`;
    }
    case "bank_page": {
      return doc.lang === defaultLanguage
        ? `/${doc.uid}/`
        : `/${doc.lang.split("-")[0]}/${doc.uid}/`;
    }
    case "my_home_3": {
      return doc.lang === defaultLanguage
        ? `/${doc.uid}/`
        : `/${doc.lang.split("-")[0]}/${doc.uid}/`;
    }
    default: {
      return "/";
    }
  }
};
